import { Flex, Image } from '@mantine/core';
import { useMediaQueryGs } from 'app/hooks/useMediaQuery';
import { Colors, Text, Typography } from 'goalsetter-webapp-components';
import {
  breakWordStyle,
  flipStyle,
  secondFlipImageStyle,
  secondFlipTopText,
} from './styles';
import { t } from 'i18next';

interface SecondFlipProps {
  whoIsCardFor?: string;
  investorFullName?: string;
  internalDescription?: string;
  goalcardImg?: string;
  amount?: number;
}

export const SecondFlip: React.FC<SecondFlipProps> = ({
  goalcardImg,
  amount,
  whoIsCardFor,
  investorFullName,
  internalDescription,
}) => {
  const { isMobile } = useMediaQueryGs();
  return (
    <Flex
      direction={isMobile ? 'column' : 'row'}
      gap="10px"
      style={flipStyle}
    >
      <Image
        src={goalcardImg}
        alt="Img"
        className="img-responsive"
        style={secondFlipImageStyle(isMobile)}
      />
      <Flex direction="column">
        <Flex direction="column">
          <Flex
            direction="column"
            align="flex-end"
            style={secondFlipTopText}
          >
            <Text
              color={Colors.WHITE}
              type={Typography.GSBODY2}
            >
              {t('animatedGoalCard.goalcard')}
            </Text>
            <Text
              color={Colors.WHITE}
              type={Typography.GSH4}
            >
              ${amount?.toFixed(2)}
            </Text>
          </Flex>
          <Text
            color={Colors.WHITE}
            type={Typography.GSBODY2}
          >
            {t('animatedGoalCard.goalcardTo')}
          </Text>
          <Text
            color={Colors.WHITE}
            type={isMobile ? Typography.GSH6 : Typography.GSH5}
            style={breakWordStyle(isMobile)}
          >
            {whoIsCardFor?.toLowerCase()}
          </Text>
          <Text
            color={Colors.WHITE}
            type={Typography.GSBODY2}
          >
            {t('animatedGoalCard.goalcardFrom')}
          </Text>
          <Text
            color={Colors.WHITE}
            type={isMobile ? Typography.GSH6 : Typography.GSH5}
            style={breakWordStyle(isMobile)}
          >
            {investorFullName}
          </Text>
          <Text
            color={Colors.WHITE}
            type={Typography.GSBODY2}
          >
            {t('animatedGoalCard.goalcardFor')}
          </Text>
          <Text
            color={Colors.WHITE}
            type={isMobile ? Typography.GSH6 : Typography.GSH5}
            style={breakWordStyle(isMobile)}
          >
            {internalDescription}
          </Text>
        </Flex>
      </Flex>
    </Flex>
  );
};
